import { KeyIssueIcon, KeyIssueIconGlyph } from "./key-issue-icon";
export var TopicIcon = KeyIssueIcon;
export var TopicIconGlyph = KeyIssueIconGlyph;